import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import { StorageService } from 'src/app/modules/shared/services/storage.service';

declare var $: any;

@Component({
    selector: 'app-question-summary-nocalc',
    templateUrl: './question-summary-nocalc.component.html',
    styleUrls: ['./question-summary-nocalc.component.scss'],
    standalone: false
})
export class QuestionSummaryNoCalcComponent implements OnInit, OnChanges, OnDestroy {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  summaryDataSubscription: Subscription;
  locations: any;

  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private storageService: StorageService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }


  ngOnInit(): void {
    
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }

    this.summaryDataSubscription = this.questionService.summaryData
      .subscribe(v => {
        if (v) {
          if (!this.isSavingData) {
            //this.getPageData();
          }
          this.questionService.setSummaryDataObservable(false);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.question);
    this.setupLocations();
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      if (!this.isSavingData) {
        //this.getPageData();
      }
    }
  }
 setupLocations(): void{
  this.locations = JSON.parse(this.question?.options);
  console.log(this.locations);
  this.question.answer = 'continue';
  this.questionAnswer.emit(this.question);
 }
  getPageData(): void {
    if (this.question) {
      this.questionService.spinner(true);
      this.isSavingData = true;
      this.summaryCollations = [];
      this.classes = [];
      this.questionService.updatePrices(this.question?.product_id, this.question.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('quote')
            .subscribe(dataset => {
              this.product = this.questionService.getIndexData(4, dataset)[0];
              this.collations = this.questionService.getIndexData(2, dataset);
              this.classes = this.collations.filter(item => item.entry_type === 'class_total' && item.mandatory !== 1 && item.frequency_id === this.questionService?.currency.frequency_id && item?.product_id === this.question?.product_id);
              this.summary.pageDataProduct = this.product;
              this.summary.person = this.questionService.getIndexData(1, dataset)[0];
              this.summary.collations = this.collations;
              this.onSummaryDataChanged.emit({collations: this.collations, product: this.product});
              this.setupCollation();

              console.log(this.collations);

            }, error => {
              this.questionService.spinner(false);
              this.isSavingData = false;
            });
        }, error => {
          this.questionService.spinner(false);
          this.isSavingData = false;
        });
    }
  }

  setupCollation(): void {
    if (this.question) {
      for (const c of this.collations) {
        if (c.product_id === this.question.product_id && c.entry_type === 'item' && c.frequency_id === 3 && c.mandatory !== 1) {
          c.discountList = [];
          const discountList = c.discounts.split(',');
          for (const item of discountList) {
            const dl = item.split(':');
            if (dl[1]) {
              c.discountList.push(dl[1]);
            }
          }
          this.summaryCollations.push(c);
        }
      }
      this.question.answer = 'continue';
      try { this.question.answer = this.parameter[0]?.value; } catch (e) { }
      this.questionAnswer.emit(this.question);
      this.questionService.setShoppingCart(this.question, '0');
      this.isSavingData = false;
      this.questionService.spinner(false);
    }
    if (this.summaryCollations.length === 0) {
      this.flowPlayer.startFlow(this.sessionDetails.superflow_id, 31, this.sessionDetails.category_id, this.sessionDetails.group_id, '0', this.sessionDetails.session_id,this.sessionDetails.css, 0);
    }
  }

  getItems(class_id: number): any {
    return this.summaryCollations.filter((item: { class_id: number }) => item.class_id === class_id);
  }

  editItem(collation: QuestionFlowCollation): void {
    console.log(collation)
    this.showEditModal.emit({
      collations: this.collations,
      collation,
      product: this.product,
      person: this.summary.person,
      path: '3'
    });

    const main_session = {
      session: this.sessionDetails,
      question: this.question,
      current_page: 'summary',
    };
    this.storageService.setJson('main_session', main_session, 'flow');
  }
  checkAddAnother(): boolean {
    try {
      if (this.parameter[1]?.value === 'add_another') {
        return true;
      }
      else {
        return false;
      }
    }
    catch {
      return false;
    }
  }
  gotToNext(): void {
    var a = '';
    try { a = this.parameter[1]?.value } catch (e) { };
    this.question.answer = a;
    this.submitResponse.next(undefined);
  }

  ngOnDestroy(): void {
    this.summaryDataSubscription.unsubscribe();
  }
}
